import React from 'react';
import './Success.less';

export const Success = ({text}) => {
	return <div className="success">{text}</div>
}
